import { useMutation } from '@apollo/client';

import { MarkQuoteAsAcceptedDocument } from './graphql/markQuoteAsAccepted.gql';

export const useMarkQuoteAsAccepted = (quoteId: string) =>
  useMutation(MarkQuoteAsAcceptedDocument, {
    awaitRefetchQueries: true,
    variables: { input: { quoteId } },
  });
